<div class='devo-pipeline-tab-2-part'>
	This is devo-pipeline tab 2
</div>